// types
import { CategoryAllocation, ComponentAllocation, Conversion, Loan } from '../@types';

// props
export interface GetAllocationParams {
	allocations: CategoryAllocation[] | ComponentAllocation[];
	currency?: string;
	loanId: number;
}

/*
Get allocation by loan ID and optionally by currency.
If currency is provided and matches a conversion currency, returns the conversion.
Otherwise returns the base allocation.
 */
export const getAllocation = ({
	allocations,
	currency,
	loanId,
}: GetAllocationParams): CategoryAllocation | ComponentAllocation | Conversion | undefined => {
	// Find allocation by loan
	const allocation = (allocations as (CategoryAllocation | ComponentAllocation)[]).find((a) => {
		const allocationLoanId = typeof a.loan === 'object' ? (a.loan as Loan).id : a.loan;
		return allocationLoanId === loanId;
	});

	if (!allocation) {
		return undefined;
	}

	// If no currency specified, return the allocation
	if (!currency) {
		return allocation;
	}

	// Check if the allocation's base currency matches
	if (allocation.currency === currency) {
		return allocation;
	}

	// Check if any conversion currency matches and return the conversion
	const conversion = allocation.conversions?.find(
		(conversion: Conversion) => conversion.currency === currency
	);

	if (conversion) {
		return conversion;
	}

	return undefined;
};
